// Stephanet links screens by their catalog key (/s/<key>). Here a key is a Payroll screen, an HR & People screen (attendance, leave …),
// or not ported (null: shown as plain text).
import { findSubmodule, payrollSubUrl } from './catalog';
import { findSubmodule as findHR, hrSubUrl } from '../hr/catalog';

export const pyTo = k => (findSubmodule(k) ? payrollSubUrl(k) : findHR(k) ? hrSubUrl(k) : null);
